<script lang="ts">
  import { onMount } from "svelte";
  import { watchGTM, watchPlausible } from "../support/analytics";

  export let gtmContainerId: string | null;
  export let gaMeasurementId: string | null;
  export let plausibleDomain: string | null;

  onMount(function () {
    if (gtmContainerId) {
      watchGTM();
    }

    if (plausibleDomain) {
      watchPlausible(plausibleDomain);
    }
  });
</script>

<svelte:head>
  {#if gtmContainerId}
    <!-- Google Tag Manager -->
    {@html `
      <script>
        (function (w, d, s, l, i) {
          w[l] = w[l] || [];
          w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
          var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s),
            dl = l != "dataLayer" ? "&l=" + l : "";
          j.async = true;
          j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
          f.parentNode.insertBefore(j, f);
        })(window, document, "script", "dataLayer", "${gtmContainerId}");
      </script>
    `}
    <!-- End Google Tag Manager -->
  {/if}

  {#if gaMeasurementId}
    <!-- Google Tag -->
    <script async src="https://www.googletagmanager.com/gtag/js?id={gaMeasurementId}"></script>

    {@html `
      <script>
        window.dataLayer = window.dataLayer || [];

        function gtag() {
          window.dataLayer.push(arguments);
        }
        gtag("js", new Date());
        gtag("config", "${gaMeasurementId}");
      </script>
    `}
    <!-- End Google Tag -->
  {/if}
</svelte:head>

{#if gtmContainerId}
  <noscript>
    <iframe
      title="google tag manager"
      src="https://www.googletagmanager.com/ns.html?id={gtmContainerId}"
      height="0"
      width="0"
      style="display:none;visibility:hidden"
    ></iframe>
  </noscript>
{/if}
